module.exports = __webpack_public_path__ + "img/tool_eraser_out.fead18a6.png";